<div class="messages-container" [class.ux-improvements]="showUxImprovements">
  <div class="msg-ai" id="ai-chat-starter">
    @if (showUxImprovements) {
      @if (status === AiChatStatus.IDLE && messages().length === 0) {
        <div class="msg-row landing-header">
          <div class="msg-sender">
            <ds-icon [icon]="Icons.LevelAccess" [scale]="IconScale.FA_1_5X"></ds-icon>
          </div>
          <div class="msg-content">
            <app-ai-chat-markdown-view
              class="landing-title"
              [value]="'ai_chat_description_full_screen' | translate"
            ></app-ai-chat-markdown-view>
          </div>
        </div>
      }
    } @else {
      <div class="msg-row">
        <div class="msg-sender">
          <ds-icon [icon]="Icons.LevelAccess"></ds-icon>
        </div>
        <div class="msg-content">
          <app-ai-chat-markdown-view [value]="'ai_chat_description' | translate"></app-ai-chat-markdown-view>
          @if (status === AiChatStatus.IDLE && messages().length === 0) {
            <app-ai-chat-sample-questions
              count="3"
              (questionSelected)="onSampleQuestionClick($event)"
            ></app-ai-chat-sample-questions>
          }
        </div>
      </div>
    }
  </div>

  @for (message of messages(); track message._id; let index = $index; let last = $last) {
    <div class="d-flex flex-column gap-3 mb-2">
      <ds-chat-bubble
        class="msg-user"
        [isCustomer]="true"
        [customerName]="userName"
        [bodyText]="message.message"
      ></ds-chat-bubble>
      <div
        class="msg-ai"
        id="ai-response-{{ message._id }}"
        #aiResponseRef
        [ngClass]="message.status"
        [attr.tabindex]="message.status === IChatMessageStatus.error ? '-1' : last ? '0' : null"
      >
        @switch (message.status) {
          @case (IChatMessageStatus.error) {
            <div class="d-flex gap-3">
              <div><ds-icon [icon]="Icons.CircleExclamation"></ds-icon></div>
              <div class="msg-error">
                <div>{{ message.error | translate }}</div>
                <button class="ps-0 btn btn-link" (click)="onRetry(message.message, index)">
                  {{ 'retry_label' | translate }}
                </button>
              </div>
            </div>
          }
          @default {
            <div class="msg-row">
              <div class="msg-sender">
                <ds-icon [icon]="Icons.LevelAccess"></ds-icon>
              </div>
              <div class="msg-content">
                @for (item of message.contentBlocks ?? []; track $index) {
                  @if (item.type === 'text') {
                    <app-ai-chat-markdown-view [value]="item.text"></app-ai-chat-markdown-view>
                  } @else if (item.type === 'ui-component') {
                    <app-ai-chat-generative-item [chunk]="item"></app-ai-chat-generative-item>
                  }
                }
                @if (message.status === IChatMessageStatus.processing && hasResponseStreamPaused()) {
                  <div class="d-flex gap-2">
                    @if (!activeToolCall()) {
                      <span>{{ 'ai_response_loading' | translate }}</span>
                    }
                    @if (activeToolCall()) {
                      <ds-icon [icon]="activeToolCall().icon"></ds-icon> {{ activeToolCall().annotation | translate }}
                    }
                    <span class="loading-dots" aria-hidden="true"></span>
                  </div>
                }
                @if (message.status !== IChatMessageStatus.processing) {
                  <div class="d-flex align-items-center">
                    <ds-copy [textToCopy]="getCopyText(message)"></ds-copy>
                  </div>
                  <div class="ai-rating-buttons d-flex align-items-center mt-3">
                    <div class="rating-title me-3">{{ ratingTitle }}</div>
                    <ds-checkboxes-feedback
                      [value]="message.rating"
                      (valueChange)="onRatingChange(message, $event)"
                      [options]="ratingOptions"
                    ></ds-checkboxes-feedback>
                  </div>
                  <div class="rating-thanks-message-container" [class.has-message]="message.ratingSubmitted">
                    <div class="rating-thanks-message text-muted small mt-2">
                      {{ 'ai-chat-message-submitted' | translate }}
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    </div>
  }

  <div aria-live="polite">
    @if (status === AiChatStatus.WAITING_FOR_STATIC_RESPONSE) {
      <span class="visually-hidden">{{ 'ai_response_loading' | translate }}</span>
    } @else if (status === AiChatStatus.STREAMING_IN_PROGRESS) {
      @if (activeToolCall()?.annotation; as annotation) {
        <span class="visually-hidden">{{ annotation | translate }}</span>
      } @else {
        <span class="visually-hidden">{{
          (messages().at(-1)?.response ? 'ai_response_pending' : 'ai_response_loading') | translate
        }}</span>
      }
    }
  </div>
  <span aria-live="polite" aria-atomic="true" class="visually-hidden" data-testid="sr-zone-1">{{ firstAnnouncedChunk() }}</span>
  <span aria-live="polite" aria-atomic="true" class="visually-hidden" data-testid="sr-zone-2">{{
    remainingAnnouncedChunk()
  }}</span>
</div>
